// WebSocket 模拟器 - 用于测试 RSM 数据渲染
export class MockWebSocket {
  constructor(url) {
    this.url = url;
    this.readyState = WebSocket.CONNECTING;
    this.onopen = null;
    this.onmessage = null;
    this.onclose = null;
    this.onerror = null;

    // 模拟连接延迟
    setTimeout(() => {
      this.readyState = WebSocket.OPEN;
      if (this.onopen) {
        this.onopen();
      }
      this.startSendingMockData();
    }, 1000);
  }

  startSendingMockData() {
    // 每100ms发送一次模拟数据（10Hz）
    this.interval = setInterval(() => {
      if (this.readyState === WebSocket.OPEN && this.onmessage) {
        const mockData = this.generateMockRSMData();
        this.onmessage({ data: JSON.stringify(mockData) });
      }
    }, 100);
  }

  generateMockRSMData() {
    const timestamp = Date.now();
    const participants = [];

    // 生成3-5个随机车辆
    const vehicleCount = Math.floor(Math.random() * 3) + 3;

    for (let i = 0; i < vehicleCount; i++) {
      // 在昆明街道附近生成随机位置
      const baseLng = 102.98946;
      const baseLat = 25.118314;
      const range = 0.002; // 约200米范围

      participants.push({
        ptcId: 10 + i,
        ptcType: 1, // 机动车
        sourceType: 7,
        ptcTimestamp: timestamp,
        longitude: baseLng + (Math.random() - 0.5) * range,
        latitude: baseLat + (Math.random() - 0.5) * range,
        elevation: Math.random() * 5,
        speed: Math.random() * 15 + 5, // 5-20 m/s
        heading: Math.random() * 360,
        width: 180 + Math.random() * 40, // 180-220 cm
        length: 400 + Math.random() * 100, // 400-500 cm
        height: 150 + Math.random() * 30, // 150-180 cm
        vehicleClass: 1,
        fuelType: Math.floor(Math.random() * 5),
        transmission: Math.floor(Math.random() * 4),
        lonAccel: (Math.random() - 0.5) * 4,
        latAccel: (Math.random() - 0.5) * 4,
        vertAccel: (Math.random() - 0.5) * 2,
        yawRate: (Math.random() - 0.5) * 10,
        posConfidence: Math.floor(Math.random() * 16),
        spdConfidence: Math.floor(Math.random() * 8),
        headConfidence: Math.floor(Math.random() * 8),
      });
    }

    // 生成1-2个行人
    const pedestrianCount = Math.floor(Math.random() * 2) + 1;

    for (let i = 0; i < pedestrianCount; i++) {
      const baseLng = 102.98946;
      const baseLat = 25.118314;
      const range = 0.001; // 约100米范围

      participants.push({
        ptcId: 100 + i,
        ptcType: 3, // 行人
        sourceType: 7,
        ptcTimestamp: timestamp,
        longitude: baseLng + (Math.random() - 0.5) * range,
        latitude: baseLat + (Math.random() - 0.5) * range,
        elevation: Math.random() * 2,
        speed: Math.random() * 3 + 1, // 1-4 m/s
        heading: Math.random() * 360,
        width: 50 + Math.random() * 20, // 50-70 cm
        length: 30 + Math.random() * 10, // 30-40 cm
        height: 160 + Math.random() * 30, // 160-190 cm
        vehicleClass: 0,
        fuelType: 0,
        transmission: 0,
        lonAccel: 0,
        latAccel: 0,
        vertAccel: 0,
        yawRate: 0,
        posConfidence: Math.floor(Math.random() * 16),
        spdConfidence: Math.floor(Math.random() * 8),
        headConfidence: Math.floor(Math.random() * 8),
      });
    }

    return {
      msgType: "rsm",
      rsuId: "SN02000001",
      msgCnt: Math.floor(Math.random() * 128),
      timestamp: timestamp,
      refLongitude: 102.98946,
      refLatitude: 25.118314,
      refElevation: 0,
      uuid: `mock_${timestamp}_${Math.floor(Math.random() * 1000)}`,
      participants: participants,
    };
  }

  close() {
    console.log('🔄 MockWebSocket正在关闭...');
    
    // 立即设置状态为关闭中
    this.readyState = WebSocket.CLOSING;
    
    // 强制清理定时器
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
      console.log('✅ MockWebSocket定时器已清理');
    }
    
    // 移除所有事件监听器
    this.onopen = null;
    this.onmessage = null;
    this.onerror = null;
    
    // 设置状态为已关闭
    this.readyState = WebSocket.CLOSED;
    
    // 触发关闭事件（需要在清理监听器之前保存引用）
    const closeHandler = this.onclose;
    this.onclose = null;
    
    if (closeHandler) {
      try {
        closeHandler();
        console.log('✅ MockWebSocket关闭事件已触发');
      } catch (error) {
        console.error('❌ MockWebSocket关闭事件处理失败:', error);
      }
    }
    
    console.log('✅ MockWebSocket已完全关闭');
  }

  send(data) {
    // 模拟发送数据（在这个demo中不需要）
    console.log("Mock WebSocket send:", data);
  }
}

// 模拟 WebSocket 常量
MockWebSocket.CONNECTING = 0;
MockWebSocket.OPEN = 1;
MockWebSocket.CLOSING = 2;
MockWebSocket.CLOSED = 3;
